import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";
import { Col, Container, Row } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import userEvent from "@testing-library/user-event";

//TODO: put content inside https://www.npmjs.com/package/react-scrollbar

const ScrollBar = {
  overflowY: "scroll",
  overflowX: "scroll",
  height: "100%",
  border: "1px solid white",
  float: "center",
  position: "relative",
};

const ProjectDetails = (props) => {
  const style = {
    paddingTop: 50,
    paddingBottom: 50,
    paddingLeft: 50,
    paddingRight: 50,
  };

  let [projectDescription, setProjectDescription] = useState(null);

  useEffect(() => {
    fetch(props.projectDescription)
      .then((r) => r.text())
      .then((text) => {
        setProjectDescription(text);
      });
  }, []);

  return (
    <div style={ScrollBar}>
      <Container fluid>
        <Row>
          <Col>
            <ReactMarkdown>{projectDescription}</ReactMarkdown>

            <div>
              <ReactPlayer url={props.videoUrl} />
              <ReactPlayer url={props.videoUrl} />
              <ReactPlayer url={props.videoUrl} />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProjectDetails;
